
import styled from 'styled-components'

import FONTS from 'constants/fonts'
import COLORS from 'constants/colors'
import MEDIA from 'constants/media'


export const NewsItemWrap = styled.div`
  max-width: 640px;
  margin: 0 auto 30px;
`

export const NewsItemMeta = styled.span`
  text-transform: uppercase;
  font-size: ${FONTS.WEIGHTLIGHT};
  span {
    display: block;
  }
`

export const NewsItemTitle = styled.h4`
  font-size: ${FONTS.PARAGRAPHMOBILE};
  font-weight: ${FONTS.WEIGHTLIGHT};
  font-family: ${FONTS.FAMILYPRIMARY};
  margin: 0;
  a:link,
  a:visited {
    color: ${COLORS.BLACK};
  }
  ${MEDIA.medium`
    font-size: ${FONTS.PARAGRAPH};
  `}
`
